export default ".corporate-awards-bg {\n  background-color: #0f0f0f !important;\n}\n\n.individual-awards-bg {\n  background-color: #18191a !important;\n}";